module.exports = __webpack_public_path__ + "static/media/img64.de236e45.jpg";